import { TRPCClientError } from '@trpc/client'
import { TRPCError } from '@trpc/server'
import { TRPC_ERROR_CODES_BY_KEY } from '@trpc/server/rpc'
import { match, P } from 'ts-pattern'

export const isErrorKey = (
  error: unknown,
  key: keyof typeof TRPC_ERROR_CODES_BY_KEY
): error is Error => {
  return match(error)
    .returnType<boolean>()
    .with(
      P.instanceOf(TRPCClientError),
      (input) =>
        (input.cause instanceof TRPCError && input.cause.code === key) ||
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- we trust the type
        input.data?.code === key
    )
    .with(P.instanceOf(TRPCError), ({ code }) => code === key)
    .otherwise(
      (input) =>
        JSON.stringify(input).toLowerCase().includes(key.toLowerCase()) ||
        JSON.stringify(input).includes(String(TRPC_ERROR_CODES_BY_KEY[key]))
    )
}

export const isUnauthorised = (error: unknown): boolean => {
  return isErrorKey(error, 'UNAUTHORIZED')
}

export const isNotFound = (error: unknown): boolean => {
  return isErrorKey(error, 'NOT_FOUND')
}

export const isForbidden = (error: unknown): boolean => {
  return isErrorKey(error, 'FORBIDDEN')
}

export const isBadRequest = (error: unknown): boolean => {
  return isErrorKey(error, 'BAD_REQUEST')
}

export const isBadGateway = (error: unknown): boolean => {
  return isErrorKey(error, 'BAD_GATEWAY')
}

export const isInternalServerError = (error: unknown): boolean => {
  return isErrorKey(error, 'INTERNAL_SERVER_ERROR')
}
